<template>
  <div>
    <row 
    v-for="item in sortedItems" 
    :key="item.id"
    :createNewItem="createNewItem"
    :tier="0"
    :widgetMode="widgetMode"
    :renameItem="renameItem"
    :editable="editable"
    :onDelete="onDelete"
    :selected.sync="localSelected"
    :onClick="onClick"
    :item="item"></row>
  </div>
</template>

<script>
import Row from './row'
export default {
  props: ['items', 'widgetMode', 'onClick', 'createNewItem', 'renameItem', 'onDelete', 'selected', 'editable'],
  components: {
    Row
  },
  computed: {
    sortedItems () {
      return this.items.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    },
    localSelected: {
      get () {
        return this.selected
      },
      set (nv) {
        this.$emit('update:selected', nv)
      }
    }
  }
}
</script>
